import React, { useState, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';

const STAR_VALUES = [5, 4, 3, 2, 1];

const EditRating = forwardRef(({ saveRating }, ref) => {
    const [identifier, setIdentifier] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [theReview, setTheReview] = useState({ client: '', comment: '', stars: 0 });

    const goEditRating = (event, theIdentifier, theComment, theStars, theClient) => {
        if (event) event.preventDefault();
        setIdentifier(theIdentifier);
        setIsVisible(true);
        setTheReview({ client: theClient || '', comment: theComment || '', stars: theStars });
        document.closeModalExtra = () => editRating_close(false);
    };

    const editRating_close = (event) => {
        if (event) event.preventDefault();
        setIdentifier(false);
        setIsVisible(false);
    };

    const editRating_save = (event) => {
        if (event) event.preventDefault();
        saveRating(false, identifier, theReview.comment, parseInt(theReview.stars));
        editRating_close();
    };

    const reviewStar_click = (event, theStars) => {
        event.preventDefault();
        setTheReview(prev => ({ ...prev, stars: theStars.toString() }));
    };

    const reviewStar_move = (event) => {
        const touchobj = event.changedTouches[0];
        const checkHit = (el) => touchobj.clientX > el.left && touchobj.clientX < el.right;

        let theHitStar = false;
        for (let i = 1; i <= 5; i++) {
            const rect = document.getElementById(`labelForStar${i}`)?.getBoundingClientRect();
            if (rect && checkHit(rect)) { theHitStar = i; break; }
        }
        if (theHitStar && theHitStar != theReview.stars) {
            setTheReview(prev => ({ ...prev, stars: theHitStar.toString() }));
        }
    };

    useImperativeHandle(ref, () => ({ goEditRating }));

    if (!isVisible) return null;

    const starValue = Number(theReview.stars);

    return (
        <div className="edit-rating-overlay" onClick={editRating_close}>
            <div className="edit-rating-modal" onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div className="edit-rating-modal__header">
                    <div>
                        <h3 className="edit-rating-modal__title">
                            {theReview.client ? `Edit ${theReview.client}'s Review` : 'Edit Review'}
                        </h3>
                        <p className="edit-rating-modal__subtitle">Update the star rating and comment below</p>
                    </div>
                    <button className="edit-rating-modal__close" onClick={editRating_close} type="button" aria-label="Close">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M18 6L6 18M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Body */}
                <div className="edit-rating-modal__body">

                    {/* Star Rating */}
                    <div className="edit-rating-modal__section">
                        <label className="edit-rating-modal__label">Rating</label>
                        <div className="edit-rating-modal__stars">
                            <fieldset
                                className="c-rating__wrap c-rating__wrap-modal needsclick"
                                onTouchMove={reviewStar_move}
                                id="ratingWrap"
                            >
                                {STAR_VALUES.map((val) => (
                                    <React.Fragment key={val}>
                                        <input
                                            tabIndex={6 - val}
                                            className="c-rating__input needsclick"
                                            type="radio"
                                            id={`star${val}`}
                                            name="theReview.stars"
                                            readOnly
                                            checked={starValue === val || theReview.stars === val.toString()}
                                        />
                                        <label
                                            className="c-rating__label-read-only-large needsclick"
                                            htmlFor={`star${val}`}
                                            id={`labelForStar${val}`}
                                            onClick={(e) => reviewStar_click(e, val)}
                                        >
                                            <span className="u-visually-hidden">{val} {val === 1 ? 'star' : 'stars'}</span>
                                        </label>
                                    </React.Fragment>
                                ))}
                            </fieldset>
                            <span className="edit-rating-modal__star-count">
                                {starValue > 0 ? `${starValue} / 5` : 'Select rating'}
                            </span>
                        </div>
                    </div>

                    {/* Comment */}
                    <div className="edit-rating-modal__section">
                        <label className="edit-rating-modal__label" htmlFor="edit-rating-comment">
                            Comment
                        </label>
                        <textarea
                            id="edit-rating-comment"
                            name="theReview.comment"
                            rows="4"
                            className="edit-rating-modal__textarea"
                            placeholder="Write a comment..."
                            value={theReview.comment || ''}
                            onChange={(e) => setTheReview(prev => ({ ...prev, comment: e.target.value }))}
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="edit-rating-modal__footer">
                    <button type="button" className="edit-rating-modal__btn edit-rating-modal__btn--cancel" onClick={editRating_close}>
                        Discard
                    </button>
                    <button type="button" className="edit-rating-modal__btn edit-rating-modal__btn--save" onClick={editRating_save}>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
});

EditRating.displayName = 'EditRating';

EditRating.propTypes = {
    saveRating: PropTypes.func,
};

export default EditRating;
